import { Controller } from "@hotwired/stimulus"
import "cookieconsent"

// Connects to data-controller="cookie-consent"
export default class extends Controller {
  connect() {
    window.cookieconsent.hasTransition = !(document.body.dataset.env === "test")
    window.cookieconsent.initialise({
      container: document.getElementById("cookie_consent"),
      "palette": {
        "popup": {"background": "#252e39"},
        "button": {"background": "#14a7d0"}
      },
      "position": "bottom-left"
    })
  }
}
